var Winners = class {
	constructor(btn) {
        btn.addEventListener('click', function(e){
            e.preventDefault();
            uPopup({
                addClass: 'popup-winners',
                content: document.getElementById('winners')
            });
        }, false);
	}
};

export {Winners};





































